import React from 'react';
import moment from 'moment';
import styles from './dayviewtimelinegrid.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { getIn18Text } from 'api';
import { getWeekDayStr } from '../../util';
const DateSwitch = ({ date, onChange, onClose }) => {
    const weekStr = getWeekDayStr(date) ? ` ${getWeekDayStr(date)}` : '';
    const dateStr = date.format(getIn18Text('NIANYUERI')) + weekStr;
    const onToday = () => {
        if (!moment().isSame(date.clone().startOf('day'), 'day')) {
            onChange(moment().startOf('day'));
        }
    };
    const renderClose = () => {
        if (onClose !== undefined) {
            return (React.createElement("span", { className: styles.headerClose },
                React.createElement(IconCard, { type: "close", onClick: onClose })));
        }
        return null;
    };
    return (React.createElement("div", { className: `${styles.header} header` },
        React.createElement("button", { type: "button", onClick: () => {
                onToday();
            }, style: { width: 46 }, className: styles.headerBtn }, getIn18Text('JINTIAN')),
        React.createElement("span", { style: { marginLeft: 16 }, className: styles.headerTitle }, dateStr),
        React.createElement("button", { type: "button", onClick: () => {
                onChange(date.clone().subtract(1, 'day'));
            }, style: { width: 28, marginLeft: 16 }, className: styles.fcArrowBtn },
            React.createElement("i", { className: styles.left })),
        React.createElement("button", { type: "button", onClick: () => {
                onChange(date.clone().add(1, 'day'));
            }, style: { width: 28 }, className: styles.fcRightBtn },
            React.createElement("i", { className: styles.right })),
        renderClose()));
};
export default DateSwitch;
